export default __webpack_public_path__ + "static/media/celo-apes-transparent.807dc3ba.gif";